import type { MenuConfig } from '~typings/menu'

import permisosCxP, { RESOURCE_CXP } from '@/auth/permissions/modules/cxp'
import * as names from '@routes/cxp/nombres/configuracion'

const { configuracion } = permisosCxP
export default [
    {
        title: 'cuentas_x_pagar.subopciones.permisos_niveles_aprobacion',
        route: names.ROUTE_NIVEL_APROBACION_ANTICIPOS,
        resource: RESOURCE_CXP,
        action: configuracion.nivelAprobacionAnticipos,
    },
    {
        title: 'cuentas_x_pagar.subopciones.configuracion_asignacion_tareas',
        route: names.ROUTE_ASIGNACION_TAREAS,
        resource: RESOURCE_CXP,
        action: configuracion.asignacionTareas,
    },
    {
        title: 'cuentas_x_pagar.subopciones.fecha_limite_regdoc',
        route: names.ROUTE_FECHA_LIMITE_REGDOC,
        resource: RESOURCE_CXP,
        action: configuracion.fechaLimiteRegdoc,
    },
    {
        title: 'cuentas_x_pagar.subopciones.correo_alertas_pendientes',
        route: names.ROUTE_CORREO_ALERTAS_PENDIENTE,
        resource: RESOURCE_CXP,
        action: configuracion.correoAlertasPendientes,
    },
    {
        title: 'cuentas_x_pagar.subopciones.configuracion_alertas',
        route: names.ROUTE_USUARIOS_NOTIFICACION,
        resource: RESOURCE_CXP,
        action: configuracion.usuariosNotificacion,
    },
] as MenuConfig[]
